import {z} from "zod"

export type BatchUpdateProperty = "addTagId" | "assignUserId" | "nextActor" | "paymentState" | "removeTagId" | "removeUserAssignment" | "state"
export type BatchUpdateType = (property: BatchUpdateProperty, value: string | boolean) => Promise<number>
export type BatchMenuItem<EntityType extends {id: string; legacyId?: number}> = {
    groupLabel: string
    items: {
        label: string
        operation: (item: EntityType) => Promise<boolean>
        text?: string
        tooltip?: string
    }[]
}

export type ExtraBatchActionItem<EntityType extends {id: string; legacyId?: number}> =
    | BatchMenuItem<EntityType>
    | {groupLabel: string; items: (BatchMenuItem<EntityType> | BatchMenuItem<EntityType>["items"][0])[]}

export function isExtraBatchActionItemWithSubItems<EntityType extends {id: string; legacyId?: number}>(
    item: BatchMenuItem<EntityType> | BatchMenuItem<EntityType>["items"][0],
): boolean {
    return z.object({groupLabel: z.string()}).safeParse(item).success
}

export type BatchDownloadData<EntityType extends {id: string; legacyId?: number}> = {
    pathInMenu: string
    getDataObjectsForDownload: (item: EntityType) => Promise<{path: string; dataObjectLegacyId: number}[]>
}

export type AdvancedAction = {
    label: string
    operation: () => Promise<void> | void
    tooltip?: string
}

export type SortCriterion = {
    label: string
    operation: () => Promise<void> | void
    active?: boolean
}

export const emptyBatchEditInfo = {
    running: false,
    total: 0,
    numSucceeded: 0,
    numSkipped: 0,
    numErrored: 0,
}
